const prd = {
  GO_ENDPOINT: 'https://api.vegetablesale.jp/v1/vegetable',
  SLS_GO_ENDPOINT: 'https://api.vegetablesale.jp/v1/admin/vegetable',
  COGNITO_REGION: 'ap-northeast-1',
  COGNITO_USER_POOL_ID: 'ap-northeast-1_jNuVgXpDz',
  COGNITO_CLIENT_ID: '6jforqkoqumi9j8l9m1d1bujc',
};

export {prd};
